import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGoogleAPI } from './google-api.model';

@Injectable()
export class GoogleAPIService implements IGoogleAPI {
  private readonly BASE_URL: string = 'api/google';

  constructor(
    private http: HttpClient
  ) { }

  getChannelSubscriptionsForUserId(userId: number): Observable<any> {
    const url = `${this.BASE_URL}/subscription/user/${userId}`;
    return this.http.get(url);
  }

  deleteChannelSubscriptionById(subscriptionId: string): Observable<any> {
    const url = `${this.BASE_URL}/subscription/${subscriptionId}`;
    return this.http.delete(url);
  }

}
